module.exports = __webpack_public_path__ + "img/icon_GEMS.9d32246a.png";